export default "__VITE_ASSET__2EzrN3WB__"